"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonWithIcon = exports.StyledButton = exports.DeterminateLinearProgress = exports.SummaryHeaderWithIcon = exports.StepperShimmerLine = exports.StepperShimmerSquare = exports.StepperShimmerCircle = exports.StepperSkeletonContainer = exports.MobileHeaderSkeleton = exports.AppointmentPatientInfoLine = exports.AppointmentPatientInfo = exports.PrintButtonContainer = exports.PageHeading = exports.MobileHeaderContent = exports.StepperContainer = exports.Container = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
const breakpoints_1 = require("../../lib/constants/breakpoints");
const progress_1 = __importDefault(require("@kyruus/progress"));
const button_1 = __importStar(require("@kyruus/button"));
const containerHeight = `height: ${breakpoints_1.HEADER_HEIGHT};`;
exports.Container = (0, styled_1.default)('div') `
  background: ${(0, ui_theme_1.fromTheme)('color_background')};
  z-index: 100;
  width: 100%;
  position: sticky;
  top: 0;

  > div:first-of-type {
    // this is the MUI-stepper component
    // it changes in height as steps are selected due to font changes
    // so we need to constrain it
    > div:first-of-type {
      ${({ aboveMd }) => aboveMd && containerHeight};
    }
  }
`;
exports.StepperContainer = (0, styled_1.default)('div') `
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_large')};
  button {
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
  }

  a {
    padding: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    padding-left: 0;
  }

  .MuiStepper-root {
    padding-right: 0;

    > div span {
      font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
    }

    // Removing left margin of first step
    > div:nth-of-type(1) {
      padding-left: 0;
    }

    // Removing right margin of last step
    > div:nth-last-of-type(1) {
      padding-right: 0;
    }
  }
`;
exports.MobileHeaderContent = (0, styled_1.default)('div') `
  margin-bottom: 0px;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} ${(0, ui_theme_1.fromTheme)('spacing_large')};
  display: flex;
  align-items: center;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};

  button {
    padding: 0px;
    color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
    :first-child {
      left: 0;
      padding-right: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    }
  }

  a {
    margin-left: auto;
    padding: 0px;
    color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
  }

  @media print {
    display: none;
  }
`;
exports.PageHeading = styled_1.default.div `
  display: inline-flex;
  width: 100%;
  align-items: center;
  min-height: 42px;
  margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0px ${(0, ui_theme_1.fromTheme)('spacing_small')} 0px;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    min-height: 50px;
    margin-top: 13px;
    margin-bottom: 0px;
  }
  & > h1:first-child {
    flex-grow: 1;
  }
  & > div:last-child {
    position: fixed;
    z-index: 1000;
    box-sizing: border-box;
    left: 0px;
    bottom: 0px;
    width: 100%;
    padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
    border-top: ${(0, ui_theme_1.fromTheme)('border_style')} ${(0, ui_theme_1.fromTheme)('border_width')}
      ${(0, ui_theme_1.fromTheme)('color_border')};
    @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
      width: auto;
      position: static;
      padding: 0px;
      border: none;
    }
    & > button {
      width: 100%;
      @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
        width: auto;
      }
    }
    @media print {
      display: none;
    }
  }
`;
exports.PrintButtonContainer = styled_1.default.div `
  display: none;
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    display: block;
  }
`;
exports.AppointmentPatientInfo = styled_1.default.div `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
`;
exports.AppointmentPatientInfoLine = styled_1.default.div `
  margin-bottom: 4px;
`;
exports.MobileHeaderSkeleton = (0, styled_1.default)('div') `
  height: 60px;
`;
exports.StepperSkeletonContainer = (0, styled_1.default)('div') `
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 6rem;
  padding: 0 ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.StepperShimmerCircle = (0, styled_1.default)('div') `
  height: 24px;
  width: 24px;
  flex-shrink: 0;
  border-radius: 100%;
  background: ${(0, ui_theme_1.fromTheme)('color_text_disabled')};
  margin-right: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.StepperShimmerSquare = (0, styled_1.default)('div') `
  width: 100%;
  height: 24px;
  background: ${(0, ui_theme_1.fromTheme)('color_text_disabled')};
`;
exports.StepperShimmerLine = (0, styled_1.default)('div') `
  height: 2px;
  width: 30px;
  flex-shrink: 0;
  background: ${(0, ui_theme_1.fromTheme)('color_text_disabled')};
  margin-right: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  margin-left: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.SummaryHeaderWithIcon = styled_1.default.h1 `
  display: inline-flex;
  align-items: center;
  margin: 0;

  > span {
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  }

  > svg {
    min-height: ${(0, ui_theme_1.fromTheme)('font_size_heading_1')};
    min-width: ${(0, ui_theme_1.fromTheme)('font_size_heading_1')};
    margin-bottom: 5px;
    color: ${(0, ui_theme_1.fromTheme)('color_icon_green')};
  }
`;
exports.DeterminateLinearProgress = (0, styled_1.default)(progress_1.default) `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.StyledButton = (0, styled_1.default)(button_1.default) `
  padding: 0px;
`;
exports.StyledButtonWithIcon = (0, styled_1.default)(button_1.ButtonWithIcon) `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  padding-left: 0px;
`;
//# sourceMappingURL=styles.js.map